export default __webpack_public_path__ + "static/media/bellGrayDark.8c86a269.svg";